import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from './store'
import cookie from 'js-cookie'
import {
  userTokenKey,
  permissionFreePages,
  tokenFreePages
} from './utils/Config.js'
const { VUE_APP_BASE } = process.env
const base = VUE_APP_BASE ? `/${VUE_APP_BASE}/` : '/'
Vue.use(VueRouter)

const router = new VueRouter({
  base,
  routes,
  mode: 'history'
})

// 监听router push报错
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location) {
  return routerReplace.call(this, location).catch(err => err)
}

function getPermissions(menuData) {
  // 获取账号可用权限页面
  const permissions = []
  menuData.forEach(i => {
    if (i.children && i.children.length) {
      i.children.forEach(c => {
        if (!c.is_button && !permissions.includes(c.href)) {
          permissions.push(c.href)
        }
      })
    }
  })

  return permissions
}

router.beforeEach(async (to, from, next) => {
  const token = cookie.get(userTokenKey)
  const { path : toPath } = to
  Vue.prototype.$utils.unAttachScan()
  if (!token) {
    if (tokenFreePages.includes(toPath)) {
      next()
    } else {
      next('/login')
    }
  } else {
    const menus = await store.dispatch('setMenu')
    // const permissions = getPermissions(menus)
    if (permissionFreePages.includes(toPath) || menus /** && permissions.includes(toPath) */) {
      if (toPath === '/') {
        next('/index')
      } else {
        next()
      }
    } else {
      next('/404')
    }
  }
})

export { router }